import Thumbnail from 'components/utilities/thumbnail'
import Turntable from 'components/visualization/turntable'
import classNames from 'helpers/class-names'
import { FC, useState } from 'react'

interface Props {
  endpoint?: string
  thumbnail: string
  mouseOver: boolean
  className?: string
}

const SamplePartThumbnail: FC<Props> = ({
  thumbnail,
  endpoint,
  mouseOver,
  className = '',
}) => {
  const [loaded, setLoaded] = useState(false)
  const showTurntable = mouseOver && loaded

  return (
    <>
      {mouseOver && (
        <Turntable
          endpoint={endpoint}
          onLoad={() => setLoaded(true)}
          className={classNames(
            'absolute left-0 top-0 h-full w-full opacity-0 mix-blend-luminosity transition duration-500 ease-in-out',
            { 'opacity-100': loaded },
            className,
          )}
        />
      )}
      <Thumbnail
        className={classNames(
          'scale-90 opacity-100 mix-blend-luminosity transition duration-500 ease-in-out group-focus-within:scale-110 group-hover:scale-110',
          { 'opacity-0': showTurntable },
        )}
        src={thumbnail}
      />
    </>
  )
}

export default SamplePartThumbnail
